import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import ChatPage, { getDefaultPageUI } from "components/pages/ChatPage";

export default function CaptureChatMessageOpen(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "showInitialMessage" ], false)
        .submit();

    return <ChatPage ui={ ui } />
}